<div *ngIf="paymentData.invoices === undefined">
    <span class="spinner-grow spinner-grow-lg" role="status" aria-hidden="true"></span>
    <span class="spinner-grow spinner-grow-lg" role="status" aria-hidden="true"></span>
    <span class="spinner-grow spinner-grow-lg" role="status" aria-hidden="true"></span>
    <span class="spinner-grow spinner-grow-lg" role="status" aria-hidden="true"></span>
    <span class="spinner-grow spinner-grow-lg" role="status" aria-hidden="true"></span>
</div>


<div id="bill" *ngIf="type=='bill'">
    <form id="frmBill" class="frm-card" #formBill="ngForm" novalidate>
        <div class="wallet green-box">
            <!-- No saved pay method -->
            <div>
                <img src="ui/assets/img/Line_Payment_Step1.svg" class="tracker-img"/>
                <br/>
                <br/>
                <div *ngIf="!customPay; else billCustomPay">
                    <div class="header ph">Review Bills</div>
                    <div class="row no-margin common-p"
                         *ngIf="paymentHubComponent?.defaultSettings?.settings.futurePayments">
                        <div class="no-padding pmt-date-label pr-15 bold">
                            Payment Date
                        </div>
                        <div class="no-padding pmt-date">
                            <div role="wrapper"
                                 class="gj-datepicker gj-datepicker-bootstrap gj-unselectable input-group position-inherit">
                                <input name="paymentDate" class="form-input-date datepicker5 form-control" required
                                       data-type="datepicker" data-datepicker="true" role="input"
                                       [(ngModel)]="paymentData.paymentDate" [minDate]="currentDayDatePicker" ngbDatepicker #paymentDate="ngModel"
                                       #ds="ngbDatepicker" [maxDate]="paymentMaxDate" placement="bottom-right">
                                <span class="input-group-append" role="right-icon">
                                    <button class="btn btn-outline-secondary border-left-0 payment-date-btn" type="button"
                                            (click)="ds.toggle()" type="button">
                                        <i class="fa fa-calendar"></i>
                                    </button>
                                </span>
                            </div>
                            <div *ngIf="frmBillSubmitted && paymentDate.invalid || paymentDate.invalid && (paymentDate.dirty || paymentDate.touched)"
                                 class="invalid-feedback">
                                <div *ngIf="paymentDate.errors.required">Payment Date is required</div>
                            </div>
                        </div>
                    </div>
                    <div class="clearfix"></div>
                    <div class="responsive-table">
                        <table class="line-table type-2 invoice-tbl">
                            <tr>
                                <th style="min-width: 70px">{{LABEL_ACCOUNT_NUMBER}}</th>
                                <th style="min-width: 70px">{{LABEL_INVOICE_NUMBER}}</th>
                                <th style="min-width: 70px">{{LABEL_ACCOUNT_NAME}}</th>
                                <th style="min-width: 65px">{{LABEL_INVOICE_DATE}}</th>
                                <th style="min-width: 65px">Due Date</th>
                                <th>Payment Amount</th>
                            </tr>
                            <ng-container *ngFor="let invoice of paymentData.invoices; let i = index">
                                <tr>
                                    <td>{{invoice.accountNumber}}</td>
                                    <td>{{invoice.invoiceNumber}}</td>
                                    <td >{{invoice.name}}</td>
                                    <td>{{invoice.invoiceDate | date: 'MM/dd/yyyy'}}</td>
                                    <td>{{invoice.dueDate | date: 'MM/dd/yyyy'}}</td>
                                    <td class="tbl-data-payamt">
                                        <div class="float-right">
                                            <span class="currencyinput">
                                               <input name="paymentAmount-{{i}}" class="form-input-amt" type="text"
                                                       placeholder="$ 0.00"
                                                       (change)="invoice.amount = convertToFloat(invoice.amount, paymentHubComponent?.defaultSettings?.settings, invoice.amountDue);"
                                                        required [(ngModel)]="invoice.amount"
                                                       #paymentAmount{{i}}="ngModel"
                                                       currencyMask [options]="{ prefix: '$ ', thousands: ',', decimal: '.' }"
                                                       (blur)="invoice.amount1 = invoice.amount;updateInvoiceAmount(invoice);getTotalAmount();">
                                            </span>

                                        </div>
                                        <div *ngIf="false && (paymentHubComponent?.defaultSettings?.settings.allowOverpay && paymentHubComponent?.defaultSettings?.settings.overpayWarning && compareOverpayAmount(invoice.amount1, invoice.amountDue))"
                                             class="float-left overpay-icon" ngbTooltip="{{MESSAGE_OVERPAY_WARNING}}">
                                            <i class="fas fa-info-circle" aria-hidden="true"></i>
                                        </div>
                                    </td>
                                </tr>
                                <tr *ngIf="paymentHubComponent?.defaultSettings?.settings.shortPayPopup && compareShortpayAmount(invoice.amount1, invoice.amountDue)">
                                    <td class="common-p text-left" colspan="4">
                                        <select name="shortPayReason-{{i}}" class="select-box" required
                                                [(ngModel)]="invoice.shortPay.sid" #shortPayReason="ngModel">
                                            <option [ngValue]="null">Select a Short Pay Reason</option>
                                            <option *ngFor="let spay of shortPays" [ngValue]="spay.sid">{{spay.text}}</option>
                                        </select>
                                        <div *ngIf="frmBillSubmitted && shortPayReason.invalid || shortPayReason.invalid && (shortPayReason.dirty || shortPayReason.touched)"
                                             class="invalid-feedback">
                                            <div *ngIf="shortPayReason.errors.required">Short Pay Reason is required</div>
                                        </div>
                                    </td>
                                    <td *ngIf="invoice.shortPay.sid == '0'" class="common-p text-left" colspan="3">
                                        <input name="shortPayText-{{i}}" class="input-box short-fee-reason" required
                                               [(ngModel)]="invoice.shortPay.comment" #shortPayText="ngModel"
                                               placeholder="Enter Comment Here">
                                        <div *ngIf="frmBillSubmitted && shortPayText.invalid || shortPayText.invalid && (shortPayText.dirty || shortPayText.touched)"
                                             class="invalid-feedback">
                                            <div *ngIf="shortPayText.errors.required">Short Pay Comment is required</div>
                                        </div>
                                    </td>
                                    <td *ngIf="invoice.shortPay.sid != '0'" class="common-p text-left" colspan="3">
                                    </td>
                                </tr>
                            </ng-container>

                        </table>
                    </div>
                    <br>
                    <br>
                    <div class="row no-margin bold">
                        <div class="amt-total-label background-highlight">
                            Total Payment Amount:
                        </div>
                        <div class="amt-total background-highlight amt-due-padding-right">
                            {{totalAmount | currency:'$ '}}
                        </div>
                    </div>
                </div>
                <br/>
            </div>
        </div>
        <div class="sub-div">
            <button class="btn submit-button continue-btn"
                (click)="checkForPendingPayment(formBill)"
                type="submit">Continue</button>
        </div>
    </form>
</div>

<div id="pendingpayment" *ngIf="type=='pendingpayment'">
    <form id="frmPendingPayment" class="frm-card" #formPendingPayment="ngForm" novalidate>
        <div class="wallet green-box">
            <div class="header-warning">WARNING!</div>
            <div class="align-center"> There is already a pending payment for this account, press continue to proceed anyways</div>
        </div>
        <br/>
        <ng-container *ngFor="let pendingPayment of this.pendingPayments; let i = index">
            <div class="row no-margin bold">
                <div class="amt-total-label background-highlight">
                    Pending Payment Date:
                </div>
                <div class="amt-total background-highlight pending-due-padding-right">
                    {{pendingPayment.scheduledDate | date: 'MM/dd/yyyy'}}
                </div>
            </div>
            <div class="row no-margin bold">
                <div class="amt-total-label background-highlight">
                    Pending Payment Amount:
                </div>
                <div class="amt-total background-highlight pending-due-padding-right">
                    {{pendingPayment.total | currency:'$ '}}
                </div>
            </div>
            <br/>
        </ng-container>
        <br/>
        <div class="sub-div">
            <div class="back-button back3">
                <i class="fas fa-chevron-left" aria-hidden="true" (click)="toggleScreen('bill')"></i>
            </div>
            <button class="btn submit-button continue-btn"
                    (click)="frmBillSubmitted = true; formPendingPayment.form.valid && toggleScreen('paymethod')"
                    type="submit">Continue</button>
        </div>
    </form>
</div>

<div id="paymethod" *ngIf="type=='paymethod'">
    <form id="frmPayMethod" class="frm-card" #formPayMethod="ngForm" novalidate>
        <div class="green-box wallet">
            <img src="ui/assets/img/Line_Payment_Step2.svg" class="tracker-img"/>
            <br *ngIf="wallets.length > 0"/>
            <br *ngIf="wallets.length > 0"/>
            <div *ngIf="wallets.length > 0" class="header">Select a Saved Payment Method</div>
            <div class="clearfix"></div>
            <div class="add-method-div saved-method">
                <br>
                <div *ngIf="wallets.length > 0">
                    <div class="float-left">
                        <img src="ui/assets/img/Wallet_Selection.svg" class="wallet-icon"> 
                    </div>
                    <div class="left-header float-left">Wallet</div>
                    <div class="float-left wallet-select">
                        <select name="walletT" class="right-select" [(ngModel)]="paymentData.wallet.sid"
                            #walletT="ngModel" walletT [required]= "(!selectedPaymentMethod == null || selectedPaymentMethod == 'wallet') ? true : null"
                                (change)="changePaymentMethod('wallet')">
                            <option [selected]="true"  [ngValue]="null">Select a Saved Payment Method</option>
                            <option *ngFor="let wallet of wallets" [ngValue]="wallet.sid">
                                {{wallet.nickname}}
                                {{wallet.ccNumber}}
                                {{wallet.accountNumber}}
                            </option>
                        </select>
                    </div>
                    <div class="clearfix"></div>
                </div>

                <div *ngIf="wallets.length > 0" class="header border-top-green">Or Use New Payment Method</div>
                <div *ngIf="wallets.length == 0" class="header">Select Payment Method</div>

                <div class="input-flex">
                    <div class="add-card-button wd-50 card-detail" [hidden]="!paymentHubComponent?.defaultSettings?.settings.acceptCards" [ngClass]="[selectedPaymentMethod == 'card' ? 'active-card-btn' : '']" (click)="changePaymentMethod('card')">
                        <img src="ui/assets/img/CreditDebit_Selection.svg" class="cc-ach-icons"/>
                        <div>Credit or Debit Card</div>
                    </div>
                    <div class="add-card-button wd-50 account-detail" [hidden]="!paymentHubComponent?.defaultSettings?.settings.acceptChecks" [ngClass]="[selectedPaymentMethod == 'bank' ? 'active-card-btn' : '']" (click)="changePaymentMethod('bank')">
                        <img src="ui/assets/img/BankAccount_Selection.svg" class="cc-ach-icons"/>
                        <div>Checking Account</div>
                    </div>
                </div>
                <div *ngIf="frmPayMethodSubmitted && (!selectedPaymentMethod || (selectedPaymentMethod == 'wallet' && !formPayMethod.form.valid))" class="invalid-feedback terms_feedback">
                    Please select a payment method.
                </div>
            </div>
            <div class="clearfix"></div>
        </div>
        <div class="sub-div">
            <div class="back-button back1"><i class="fas fa-chevron-left" (click)="toggleScreen('bill')"></i></div>
            <button [class]=" selectedPaymentMethod ? 'btn submit-button continue-btn2' : 'btn disabled_button continue-btn2'"
                (click)="frmPayMethodSubmitted = true; selectedPaymentMethod && (selectedPaymentMethod == 'wallet' ? formPayMethod.form.valid && selectPaymentMethod() : selectPaymentMethod())"
                type="submit">Continue</button>
        </div>
    </form>
</div>


<div id="Reviewpay" *ngIf="type=='reviewPay'">
    <form id="frmReviewPay" class="frm-card" #formReviewPay="ngForm" novalidate>
        <div class="green-box wallet">
            <img src="ui/assets/img/Line_Payment_Step4.svg" class="tracker-img"/>
            <br/>
            <br/>
            <div class="header">Review Billing Details</div>
            <div class="confirm-details no-mr">
                <div class="align-left">Payment Date : {{getPaymentDate()}}</div>
            </div>
            <div class="clearfix"></div>
            <table class="line-table" *ngIf="!customPay; else reviewCustomPay">
                <tr>
                    <th style="min-width: 55px">{{LABEL_ACCOUNT_NUMBER}}</th>
                    <th style="min-width: 55px">{{LABEL_INVOICE_NUMBER}}</th>
                    <th style="min-width: 70px">{{LABEL_ACCOUNT_NAME}}</th>
                    <th style="min-width: 65px">{{LABEL_INVOICE_DATE}}</th>
                    <th>Payment Amount</th>
                </tr>
                <tr *ngFor="let invoice of paymentData.invoices; let i = index">
                    <td>{{invoice.accountNumber}}</td>
                    <td>{{invoice.invoiceNumber}}</td>
                    <td>{{invoice.name}}</td>
                    <td>{{invoice.invoiceDate | date: 'MM/dd/yyyy'}}</td>
                    <td class="tbl-data-payamt">{{invoice.amount | currency:'$ '}}</td>
                </tr>
            </table>
            <div class="total-count" *ngIf="applicableConvenienceFees">
                <div class="total-label">Convenience Fee</div>
                <div class="total-number">{{convenienceFeeObj.value | currency: '$ '}}</div>
            </div>
            <div class="total-count background-highlight">
                <div class="total-label">Total Payment Amount</div>
                <div class="total-number">{{totalAmount | currency: '$ '}}</div>
            </div>
            <div class="paymthod-strip background-highlight">
                <div class="align-left">Payment Method</div>
                <div class="align-right">
                    <div>{{paymentMethod}}</div>
                    <div>{{paymentMethod2}}</div>
                </div>
            </div>
            <br>
        </div>
        <div *ngIf="paymentHubComponent?.defaultSettings?.admin" class="fill-details">ENTER CUSTOMER EMAIL OR PHONE NUMBER TO AUTOMATICALLY DELIVER CONFIRMATION</div>
        <div *ngIf="!paymentHubComponent?.defaultSettings?.admin" class="fill-details">ENTER YOUR EMAIL OR PHONE NUMBER TO RECEIVE CONFIRMATION</div>
        <div class="input-flex align-center">
            <div class="form-group">
                <div class="label">Email Address</div>
                <div class="form-field-custom">
                    <input name="email" class="form-field" type="email"
                        [(ngModel)]="paymentData.contact.email" #email="ngModel" [required]="paymentHubComponent?.defaultSettings?.settings.requireEmail"
                        pattern="[a-z0-9A-Z._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,63}\s*">
                </div>
                <div *ngIf="formReviewPaySubmitted && paymentHubComponent?.defaultSettings?.settings.requireEmail || formReviewPaySubmitted && email.invalid || email.invalid && (email.dirty || email.touched)"
                    class="invalid-feedback">
                    <div *ngIf="email?.errors?.required">Email address is required</div>
                    <div *ngIf="email?.errors?.pattern">Invalid Email Address</div>
                </div>
            </div>
            <div class="form-group">
                <div class="label">Cellphone Number</div>
                <div class="form-field-custom">
                    <input name="phoneNumber" class="form-field" appPhoneMask type="tel"
                        [(ngModel)]="paymentData.contact.phoneNumber" maxlength="14">
                </div>
                <div *ngIf="formReviewPaySubmitted && !validUsPhoneNumber && !onSubmitLoader"
                    class="invalid-feedback">
                    <div *ngIf="!validUsPhoneNumber">Invalid Phone Number</div>
                </div>
                    <small>SMS charges may apply.</small>
            </div>
        </div>
        <br>
        <div *ngIf="!paymentHubComponent?.defaultSettings?.admin && !isCcPayment" class="fill-details">
            By checking the box below and clicking the "Submit Payment" button I authorize {{paymentHubComponent.defaultSettings.settings.clientName}} to debit the bank account 
            indicated on this web form for the noted amount. I understand that in the event this ACH transaction is returned by my financial institution, 
            I may be subject to a returned item fee. I have read and understand the cancellation and return policy outlined in the Terms and Conditions and 
            agree to allow {{paymentHubComponent.defaultSettings.settings.clientName}} a reasonable opportunity to act in response to it. 
        </div>
        <div *ngIf="paymentHubComponent?.defaultSettings?.admin && !isCcPayment" class="fill-details">
            By clicking the Submit Payment button, I authorize that {{paymentHubComponent.defaultSettings.settings.clientName}} has received verbal authorization from the customer to debit their bank account for a one-time transaction.  
        </div>
        <div class="sub-div flex">
            <div class="back-button back2"><i class="fas fa-chevron-left" (click)="toggleScreen('paymethod')"></i></div>
            <div class="terms">
                <input name="agree1" type="checkbox" [(ngModel)]="paymentData.agree" #agree1="ngModel" required> I agree
                to the <span class="terms-link" (click)="toggleScreen('terms')">Terms and Conditions</span>
                <div *ngIf="formReviewPaySubmitted && agree1.invalid || agree1.invalid && (agree1.dirty || agree1.touched)"
                    class="invalid-feedback terms_feedback">
                    <div *ngIf="agree1.errors.required">Please accept the Terms and Conditions</div>
                </div>
            </div>
            <button class="btn submit-button submit-pay" *ngIf="!onSubmitLoader"
                    (click)="formReviewPaySubmitted = true; isValidUsPhoneNumber(paymentData.contact.phoneNumber) && formReviewPay.form.valid && doPayment()" type="submit">Submit
                Payment</button>
            <div class="btn submit-button" *ngIf="onSubmitLoader">
                <span class="spinner-grow spinner-grow-lg" role="status" aria-hidden="true"></span>
                <span class="spinner-grow spinner-grow-lg" role="status" aria-hidden="true"></span>
                <span class="spinner-grow spinner-grow-lg" role="status" aria-hidden="true"></span>
            </div>
        </div>
        <br>
    </form>
</div>


<div id="termsConditions" class="termsAndConditions" *ngIf="type=='terms'">
    <button class="btn submit-button submit-pay" (click)="toggleScreen('reviewPay')">Back</button>
    <br/>
    <div class="innerTerms" [innerHTML]="LABEL_TERMS"></div>
    <br/>
    <div class="sub-div">
        <button class="btn submit-button submit-pay" (click)="toggleScreen('reviewPay')">Back</button>
    </div>
</div>


<div id="confirmationPage" *ngIf="type=='confirmationPage'">
    <div class="green-box wallet">
        <div *ngIf="response.status!='FAIL' && !isFutureDatedPayment()" class="header-green">Thank you for your payment!</div>
        <div *ngIf="response.status!='FAIL' && isFutureDatedPayment()" class="header-green">Your payment has been scheduled!</div>

        <div *ngIf="response.status=='FAIL'" class="header-warning">Transaction was declined.</div>
        <div *ngIf="response.status=='FAIL'" class="align-center"><small><b>Transaction message: {{response.errors.ERROR_RESPONSE}}</b></small></div>

        <div *ngIf="response.status!='FAIL'" class="align-center"><b>Confirmation #: {{response.nmiTransactionId}}</b></div>
        <div class="fill-details">REVIEW CONFIRMATION DETAILS</div>
        <div class="confirm-details no-mr">
            <div class="align-left">Submitted Date: </div>
            <div class="align-right">{{response.submittedDate}}</div>
        </div>
        <div class="confirm-details no-mr">
            <div class="align-left">Submitted Time: </div>
            <div class="align-right">{{response.submittedTime}}</div>
        </div>
        <div class="confirm-details no-mr">
            <div class="align-left">Payment Date:</div>
            <div class="align-right">{{getPaymentDate()}}</div>
        </div>
        <div class="clearfix"></div>
        <div id="tableContainer" class="tableContainer">
            <table class="line-table scrollTable" *ngIf="!customPay; else reviewCustomPay">
                <thead class="fixedHeader">
                    <tr>
                        <th style="min-width: 55px">{{LABEL_ACCOUNT_NUMBER}}</th>
                        <th style="min-width: 55px">{{LABEL_INVOICE_NUMBER}}</th>
                        <th style="min-width: 70px">{{LABEL_ACCOUNT_NAME}}</th>
                        <th style="min-width: 65px">{{LABEL_INVOICE_DATE}}</th>
                        <th>Payment Amount</th>
                    </tr>
                </thead>
                <tbody class="scrollContent">
                    <tr *ngFor="let invoice of paymentData.invoices; let i = index">
                        <td>{{invoice.accountNumber}}</td>
                        <td>{{invoice.invoiceNumber}}</td>
                        <td>{{invoice.name}}</td>
                        <td>{{invoice.invoiceDate | date: 'MM/dd/yyyy'}}</td>
                        <td class="tbl-data-payamt">{{invoice.amount | currency:'$ '}}</td>
                    </tr>
                </tbody>
            </table>
        </div>
        <div class="total-count" *ngIf="applicableConvenienceFees">
            <div class="total-label">Convenience Fee</div>
            <div class="total-number">{{convenienceFeeObj.value | currency:'$ '}}</div>
        </div>
        <div class="total-count background-highlight">
            <div class="total-label">Total Payment Amount</div>
            <div class="total-number">{{totalAmount | currency:'$ '}}</div>
        </div>
        <div class="paymthod-strip background-highlight">
            <div class="align-left">Payment Method</div>
            <div class="align-right">{{paymentMethod}}</div>
        </div>
        <br><br><br><br>
    </div>
    <div class="sub-div">
        <button class="btn submit-button print" (click)="printPage()">Print</button>
    </div>
</div>
<input size="50" type="hidden" name="amount" value="{{totalAmount}}" />


<div id="DebitCard" class="green-box" *ngIf="type == 'card' || type == 'bank'">
    <img src="ui/assets/img/Line_Payment_Step3.svg" class="tracker-img"/>
    <br/>
    <br/>
    <div *ngIf="type == 'card'" class="header">Enter Card Information</div>
    <div *ngIf="type == 'card'" class="accepted-methods">
        <img  src="ui/assets/img/VISA.svg" class="accepted-methods-img" />
        <img  src="ui/assets/img/Mastercard.svg" class="accepted-methods-img" />
        <img  src="ui/assets/img/Discover.svg" class="accepted-methods-img" />
        <img  src="ui/assets/img/American Express.svg" class="accepted-methods-img"/>
    </div>
    <div *ngIf="type == 'bank'"  class="header">Enter Bank Information</div>
    <div *ngIf="type == 'bank'" class="accepted-methods">
     <img src="ui/assets/img/ACH.svg" class="accepted-methods-img"/>
    </div>
    <div class="clearfix"></div>
    <div class="card-detail-div">
        <form class="add-card">
            <div class="form-group type1">
                <div class="label" [hidden]="type == 'bank'">Name on Card</div>
                <div class="label" [hidden]="type == 'card'">Name on Bank Account</div>
                <div id="ccName" class="form-input">
                </div>
                <div *ngIf="cardErr.checkname.flag" class="invalid-feedback">
                    <div>{{cardErr.checkname.msg}}</div>
                </div>
            </div>
            <div [hidden]="type == 'bank'" class="form-group type7">
                <div class="label">Card Number</div>
                <div id="ccNumber" class="form-input"></div>
                <div *ngIf="cardErr.ccnumber.flag" class="invalid-feedback">
                    <div>{{cardErr.ccnumber.msg}}</div>
                </div>
            </div>
            <div [hidden]="type == 'card'" class="input-flex">
                <div [hidden]="type == 'card'" class="form-group type2">
                    <div class="label">Routing Number</div>
                    <div id="routingNo" class="form-input"></div>
                    <div *ngIf="cardErr.checkaba.flag" class="invalid-feedback">
                        <div>{{cardErr.checkaba.msg}}</div>
                    </div>
                </div>
                <div class="form-group type4">
                    <div class="label">Account Number</div>
                    <div id="acNumber" class="form-input"></div>
                    <div *ngIf="cardErr.checkaccount.flag" class="invalid-feedback">
                        <div>{{cardErr.checkaccount.msg}}</div>
                    </div>
                </div>
            </div>
            <div class="input-flex">
                <div [hidden]="type == 'bank'" class="form-group type3">
                    <div class="label">Expiration Date</div>
                    <div id="ccExp" class="form-input"></div>
                    <div *ngIf="cardErr.ccexp.flag" class="invalid-feedback">
                        <div>{{cardErr.ccexp.msg}}</div>
                    </div>
                </div>
                
                <div [hidden]="type == 'bank'" class="form-group type3">
                    <div class="label">CVV</div>
                    <div id="cvv" class="form-input"></div>
                    <div *ngIf="cardErr.cvv.flag" class="invalid-feedback">
                        <div>{{cardErr.cvv.msg}}</div>
                    </div>
                </div>
                <div class="form-group type3">
                    <div class="label" [ngClass]="zipCode.invalid && zipCode.touched ? 'text-danger' : 'label control-label'">
                        ZIP Code
                    </div>
                    <div class="form-field-custom">
                        <input name="billing-postal" class="form-field-collect-js form-field" type="tel" placeholder="00000"
                               minlength="5" maxlength="7" [(ngModel)]="paymentData.wallet.zipCode" #zipCode="ngModel" required
                               pattern="^(?! )[A-Za-z0-9 ]+(?<! )$" [ngClass]="{ 'is-invalid': zipCode.invalid && zipCode.touched}" [disabled]="isDisabled">
                    </div>
                    <div *ngIf="zipCode.invalid && zipCode.touched"
                            class="invalid-feedback">
                        <div *ngIf="zipCode.errors?.required">ZIP Code is required</div>
                        <div *ngIf="zipCode.errors?.pattern">Invalid ZIP Code</div>
                        <div *ngIf="zipCode.errors?.minlength">Minimum length is 5 digits</div>
                        <div *ngIf="zipCode.errors?.maxlength">Maximum length is 7 digits</div>
                    </div>
                </div>
                <div [hidden]="type == 'card'" class="form-group type4">
                    <div class="label">
                        Business Account
                    </div>
                    <div class="form-check form-check-inline">
                        <input name="businessAccount" id="achBusinessAcctYes" type="radio" [value]=true [(ngModel)]="achBusinessAccount">
                        <div class="input-group-append">
                            <span>Yes</span>
                        </div>
                    </div>
                    <div class="form-check form-check-inline">
                        <input name="businessAccount" id="achBusinessAcctNo" type="radio" [value]=false [(ngModel)]="achBusinessAccount">
                        <div class="input-group-append">
                            <span>No</span>
                        </div>
                    </div>
                </div>
            </div>
            <div class="input-flex" [hidden]="defaultSettings?.settings.hideWallet">
                <div class="form-group">
                    <div class="form-check form-check-inline button-row" [ngbTooltip]="getSaveWalletTooltip()">
                        <input name="saveForFuture" type="checkbox" [disabled]="isFutureDatedPayment()"  [(ngModel)]="paymentData.wallet.save" #save="ngModel">
                        <div class="input-group-append">
                            <span class="save-notification"> Save For Future Use</span>
                        </div>
                    </div>
                </div>
                <div class="form-group" [hidden]="!paymentData.wallet.save">
                    <div class="label"
                        [ngClass]="nickname.invalid && nickname.touched ? 'text-danger' : 'label control-label'">
                        Payment Method Nickname
                    </div>
                    <div class="form-field-custom">
                        <input name="nickname" class="form-field" minlength="1" maxlength="20" #nickname="ngModel"
                               [(ngModel)]="paymentData.wallet.nickname" [required]="paymentData.wallet.save"
                               pattern="^(?! )[A-Za-z0-9 ]+(?<! )$" placeholder="Nickname">
                    </div>
                    <div *ngIf="nickname.invalid && nickname.touched" class="invalid-feedback" style="display: block">
                        <div *ngIf="nickname.errors?.required">Nickname is required</div>
                        <div *ngIf="nickname.errors?.pattern">Invalid Nickname</div>
                        <div *ngIf="nickname.errors?.minlength">Minimum length of 1 character</div>
                        <div *ngIf="nickname.errors?.maxlength">Maximum length of 20 characters</div>
                    </div>
                </div>
            </div>
            <br>
            <div class="sub-div">
                <div class="back-button back3">
                    <i class="fas fa-chevron-left" aria-hidden="true" (click)="toggleScreen('paymethod')"></i>
                </div>
                <button *ngIf="!onSubmitLoader" (click)="displayLoadingImage();" id="collectJsSubmissionTrigger" class="btn submit-button continue-btn" type="button"
                        [disabled]="(!defaultSettings?.settings.hideWallet && paymentData.wallet.save && nickname.invalid) || zipCode.invalid || (type == 'card' && (cardErr.checkname.flag || cardErr.ccnumber.flag || cardErr.ccexp.flag || cardErr.cvv.flag)) || (type == 'bank' && (cardErr.checkname.flag || cardErr.checkaba.flag || cardErr.checkaccount.flag))">
                    Continue
                </button>
                <div class="btn submit-button" *ngIf="onSubmitLoader">
                    <span class="spinner-grow spinner-grow-lg" role="status" aria-hidden="true"></span>
                    <span class="spinner-grow spinner-grow-lg" role="status" aria-hidden="true"></span>
                    <span class="spinner-grow spinner-grow-lg" role="status" aria-hidden="true"></span>
                </div>
            </div>
        </form>
    </div>
</div>


<div id="keypadPayment" class="green-box" *ngIf="type == 'keypad'">
    <img src="ui/assets/img/Line_Payment_Step3.svg" class="tracker-img"/>
    <br>
    <br>
    <div class="header">Enter Card Information</div>
    <div class="accepted-methods">
        <img src="ui/assets/img/VISA.svg" class="accepted-methods-img"/>
        <img src="ui/assets/img/Mastercard.svg" class="accepted-methods-img"/>
        <img src="ui/assets/img/Discover.svg" class="accepted-methods-img"/>
        <img src="ui/assets/img/American Express.svg" class="accepted-methods-img"/>
    </div>
    <div class="card-detail-div">
        <form class="add-card">
            <div class="form-group">
                <div class="label" [ngClass]="keypadCardName.invalid && keypadCardName.touched ? 'text-danger' : 'label control-label'">
                    Name on Card
                </div>
                <div class="form-field-custom">
                    <input name="keypad-card-name" class="form-field" required placeholder="Name on Card"
                           minlength="4" maxlength="100" [(ngModel)]="paymentData.wallet.name" #keypadCardName="ngModel"
                           pattern="^(?! )[A-Za-z0-9 ]+(?<! )$" [ngClass]="{'is-invalid': keypadCardName.invalid && keypadCardName.touched}">
                </div>
                <div *ngIf="keypadCardName.invalid && keypadCardName.touched"
                     class="invalid-feedback">
                    <div *ngIf="keypadCardName.errors?.required">Name on Card is required</div>
                    <div *ngIf="keypadCardName.errors?.pattern">Invalid Name on Card</div>
                    <div *ngIf="keypadCardName.errors?.minlength">Minimum length is 4 characters</div>
                    <div *ngIf="keypadCardName.errors?.maxlength">Maximum length is 100 characters</div>
                </div>
            </div>

            <div class="form-group">
                <div class="label" [ngClass]="keypadInput.invalid && keypadInput.touched ? 'text-danger' : 'label control-label'">
                    Keypad Input
                </div>
                <div [hidden]="keypadDataLocked">
                    <div class="form-field-custom">
                        <input name="keypad-input" class="form-field" type="password" minlength="160" maxlength="160"
                               [(ngModel)]="paymentData.wallet.tokenId" #keypadInput="ngModel" required
                               [ngClass]="{'is-invalid': keypadInput.invalid && keypadInput.touched}"
                               (keydown.enter)="lockKeypadDataFieldIfInputValid()" placeholder="****************">
                    </div>
                    <div *ngIf="keypadInput.invalid && keypadInput.touched"
                         class="invalid-feedback">
                        <div *ngIf="keypadInput.errors?.required">Keypad Input is required</div>
                        <div *ngIf="keypadInput.errors?.minlength">Invalid Keypad Input - Clear and Re-enter</div>
                        <div *ngIf="keypadInput.errors?.maxlength">Invalid Keypad Input - Clear and Re-enter</div>
                    </div>
                </div>
                <div [hidden]="!keypadDataLocked" class="success-text">
                    CAPTURED SUCCESSFULLY
                </div>
            </div>

            <div class="form-group">
                <div class="label" [ngClass]="keypadZipCode.invalid && keypadZipCode.touched ? 'text-danger' : 'label control-label'">
                    ZIP Code
                </div>
                <div class="form-field-custom">
                    <input name="keypad-zip-code" class="form-field" minlength="5" maxlength="7" placeholder="00000"
                           [(ngModel)]="paymentData.wallet.zipCode" #keypadZipCode="ngModel" required
                           [ngClass]="{'is-invalid': keypadZipCode.invalid && keypadZipCode.touched}"
                           pattern="^(?! )[A-Za-z0-9 ]+(?<! )$" [disabled]="isDisabled">
                </div>
                <div *ngIf="keypadZipCode.invalid && keypadZipCode.touched" class="invalid-feedback">
                    <div *ngIf="keypadZipCode.errors?.required">ZIP Code is required</div>
                    <div *ngIf="keypadZipCode.errors?.pattern">Invalid ZIP Code</div>
                    <div *ngIf="keypadZipCode.errors?.minlength">Minimum length is 5 digits</div>
                    <div *ngIf="keypadZipCode.errors?.maxlength">Maximum length is 7 digits</div>
                </div>
            </div>

            <div class="input-flex" [hidden]="defaultSettings?.settings.hideWallet">
                <div class="form-group">
                    <div class="form-check form-check-inline button-row" [ngbTooltip]="getSaveWalletTooltip()">
                        <input name="saveForFuture" type="checkbox" [disabled]="isFutureDatedPayment()"  [(ngModel)]="paymentData.wallet.save">
                        <div class="input-group-append">
                            <span class="save-notification">Save For Future Use</span>
                        </div>
                    </div>
                </div>
                <div class="form-group" [hidden]="!paymentData.wallet.save">
                    <div class="label"
                         [ngClass]="keypadNickname.invalid && keypadNickname.touched ? 'text-danger' : 'label control-label'">
                        Payment Method Nickname
                    </div>
                    <div class="form-field-custom">
                        <input name="nickname" class="form-field" minlength="1" maxlength="20" #keypadNickname="ngModel"
                               [(ngModel)]="paymentData.wallet.nickname" [required]="paymentData.wallet.save"
                               pattern="^(?! )[A-Za-z0-9 ]+(?<! )$" placeholder="Nickname">
                    </div>
                    <div *ngIf="keypadNickname.invalid && keypadNickname.touched"
                         class="invalid-feedback" style="display: block">
                        <div *ngIf="keypadNickname.errors?.required">Nickname is required</div>
                        <div *ngIf="keypadNickname.errors?.pattern">Invalid Nickname</div>
                        <div *ngIf="keypadNickname.errors?.minlength">Minimum length of 1 character</div>
                        <div *ngIf="keypadNickname.errors?.maxlength">Maximum length of 20 characters</div>
                    </div>
                </div>
            </div>
            <br>
            <div class="sub-div">
                <div class="back-button back3">
                    <i class="fas fa-chevron-left" aria-hidden="true" (click)="toggleScreen('paymethod')"></i>
                </div>
                <button *ngIf="!onSubmitLoader" (click)="displayLoadingImage(); keypadPayment();" class="btn submit-button continue-btn" type="button"
                        [disabled]="(!defaultSettings?.settings.hideWallet && paymentData.wallet.save && keypadNickname.invalid || keypadCardName.invalid || keypadInput.invalid || keypadZipCode.invalid)">
                    Continue
                </button>
                <div class="btn submit-button" *ngIf="onSubmitLoader">
                    <span class="spinner-grow spinner-grow-lg" role="status" aria-hidden="true"></span>
                    <span class="spinner-grow spinner-grow-lg" role="status" aria-hidden="true"></span>
                    <span class="spinner-grow spinner-grow-lg" role="status" aria-hidden="true"></span>
                </div>
            </div>
        </form>
    </div>
</div>

<ng-template #billCustomPay>
    <div class="add-card">
        <div class="form-group">
            <div class="label">Payment Amount</div>
            <div class="form-field-custom">
                <input id="payAmount" [(ngModel)]="paymentData.custom.amount" (blur)="getTotalAmount()" required class="form-field"
                       currencyMask [options]="{ align: 'center', decimal: '.', thousands: ',' }"
                >
            </div>
        </div>
        <div class="form-group">
            <div class="label">Invoice Number</div>
            <div class="form-field-custom">
                <input id="payInvNumber" [(ngModel)]="paymentData.custom.invoiceNumber" class="form-field" pHubCharCounter [maxChars]="26" maxlength="26" placeholder="Invoice Number (optional)">
            </div>
        </div>
        <div class="form-group">
            <div class="label">Notes</div>
            <div class="form-field-custom">
                <input id="payNotes" [(ngModel)]="paymentData.customPayNote" class="form-field" pHubCharCounter [maxChars]="38" maxlength="38" placeholder="Description / Notes">
            </div>
        </div>
    </div>
</ng-template>

<ng-template #reviewCustomPay>
    <div class="total-count">
        <div class="custom-label">Payment Amount</div>
        <div class="custom-number">{{paymentData.custom.amount | currency:'$ '}}</div>
    </div>
    <div class="total-count" *ngIf="paymentData.custom.invoiceNumber.length > 0">
        <div class="custom-label">Invoice Number</div>
        <div class="custom-number">{{paymentData.custom.invoiceNumber}}</div>
    </div>
    <div class="total-count" *ngIf="paymentData.customPayNote.length > 0">
        <div class="custom-label">Notes</div>
        <div class="custom-number">{{paymentData.customPayNote}}</div>
    </div>
</ng-template>

